import { render, staticRenderFns } from "./LastUpdate.vue?vue&type=template&id=1ac90e06&"
import script from "./LastUpdate.vue?vue&type=script&lang=js&"
export * from "./LastUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports